// @import dependencies
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import React, { CSSProperties } from 'react'
import { Modal } from 'react-bootstrap';
import ForumCategoryModule from '../admin/ForumCategoryModule/ForumCategoryModule';
// @end dependencies

// @import components
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalForumCategory.scss'
// @end styles

interface IModalForumCategoryProps {
  open: boolean
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  hideCloseButton?: boolean
  onClose?: ()=>any
}

const ModalForumCategory: React.FC<IModalForumCategoryProps> = (props) => {

  /**
   * @INFO Click en cerrar
   */
   const handleClickClose = () => {
    if(props.onClose){
      props.onClose()
    }
  }

  return(
    <Modal
      className={`modal-learning-path-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <div
          className={`modal_forum_category-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
        >
          <TextComponent
            type='subtitle'
          >
            Categorías de foros
          </TextComponent>
          <ForumCategoryModule/>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalForumCategory;
